import { LABELS } from "../../platform/config";
import type { CellBlocker, CenterChannel, NotificationEvent } from "../../services/notificationCenterService";

/** Column heading. Push reaches clients in the app and the owner in the browser. */
export const channelColumn = (channel: CenterChannel, audience: NotificationEvent["audience"]) => {
  if (channel === "PUSH") return audience === "OWNER" ? "Browser" : "App";
  return CHANNEL_NAMES[channel];
};

export const CHANNEL_NAMES: Record<CenterChannel, string> = {
  PUSH: "App notifications",
  EMAIL: "Email",
  SMS: "SMS",
  WHATSAPP: "WhatsApp",
};

export const blockerText = (blocker: CellBlocker, channel: CenterChannel): string => {
  switch (blocker) {
    case "LOCKED":
      return "Always sent. It cannot be turned off.";
    case "TEMPLATE_PENDING":
      return "Not available yet: this WhatsApp message is waiting for approval.";
    case "CHANNEL_OFF":
      return `${CHANNEL_NAMES[channel]} is not on for your account yet. See Channels below.`;
    default:
      return "Not sent on this channel.";
  }
};

/** The server says "booking"; the Appointments app says "appointment". */
export const localize = (text: string) =>
  text
    .replace(/\bBookings\b/g, LABELS.bookings)
    .replace(/\bBooking\b/g, LABELS.booking)
    .replace(/\bbookings\b/g, LABELS.bookings.toLowerCase())
    .replace(/\bbooking\b/g, LABELS.booking.toLowerCase())
    // "a booking" -> "an appointment".
    .replace(/\b(a|A) ([aeiouAEIOU])/g, "$1n $2");

export const AUDIENCE_TITLES: Record<NotificationEvent["audience"], string> = {
  CLIENT: `To your ${LABELS.clients.toLowerCase()}`,
  OWNER: "To you",
  ACCOUNT: "Account and security",
};

/** A wa.me link with the request already typed. */
export const contactUsLink = (number: string | null | undefined, message: string) =>
  number ? `https://wa.me/${number.replace(/[^\d]/g, "")}?text=${encodeURIComponent(message)}` : null;
